import Card from 'components/Layout/Card'
import React, { useState } from 'react'
import { icons } from 'utils/constants'
import { formattedDateTime } from 'utils/helpers'

const AddOnServices = ({ paperData }
) => {
    const { add_on_services } = paperData
    return (
        <Card className='cmt-10 cps-25 cpt-16 cpb-32 cpe-25'>
            <div className='text-16-400-20 color-1717 cmb-14'>
                Selected Add-ons
            </div>
            <div className="border-bottom cmb-18 color-d1d1"></div>

            {add_on_services?.length > 0 ? (
                <div className="row">
                    {add_on_services?.map(service => {
                        return (
                            <div key={service.id} className="col-6 cmb-20">
                                <div
                                    className={`cp-24 br-5 hover:shadow-lg transition-shadow duration-300 b-d1d1 ${service?.deleted_at && 'bg-F3F4F8'}`}
                                    style={{ minHeight: "200px" }}
                                >
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h3 className="color-dark-gray text-16-500-20">
                                            {service?.service_name}
                                        </h3>
                                    </div>
                                    <p className="text-14-300-24">
                                        {service?.service_description}
                                    </p>

                                    {service?.deleted_at ?
                                        <span className="text-14-400-18 color-6866 mt-auto">
                                            Removed : {formattedDateTime(service?.deleted_at)}
                                        </span> :
                                        <span className="text-14-400-18 color-6866 mt-auto">
                                            Updated : {formattedDateTime(service?.updated_at)}
                                        </span>}
                                </div>
                            </div>
                        )
                    })}
                </div>
            ) : (
                <div className="d-flex flex-column justify-content-center align-items-center cpb-125">
                    <div className="text-center cmt-56">
                        <img src={icons.circleInfo} alt="No Data" style={{ height: "40px", width: "40px" }} />
                        <h3 className="cmt-22 text-24-500-30 color-dark-gray">
                            Add-On Services Not Found
                        </h3>
                    </div>
                </div>
            )}
        </Card>
    )
}

export default AddOnServices
